/**
 * @module app.cm
 */

import * as CM from 'app/cm/models/essette-api';


abstract class CaseEvent {
    public case?: CM.Case;
}
export class CaseChangeEvent extends CaseEvent {  // Replaces case:changed
    constructor($case?: CM.Case) {
        super();
        this.case = $case;
        return Object.assign<CaseChangeEvent, CaseChangeEvent>(this, { case: $case });
    }
}

export class CaseExternalSystemChangeEvent extends CaseEvent { }

abstract class AssignCasesEvent { }
export class AssignCasesReloadEvent extends AssignCasesEvent { }
export class AssignCasesClearBulkActionEvent extends AssignCasesEvent { }

abstract class ContactLogMethodEvent { }
export class ContactLogMethodReloadEvent extends ContactLogMethodEvent { }
abstract class ContactLogOutcomeEvent { }
export class ContactLogOutcomeReloadEvent extends ContactLogOutcomeEvent { }
